import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const AdSpaceIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 32 33" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="9if3nf3csa">
          <path d="M600 0v840H0V0h600z" />
        </clipPath>
        <clipPath id="65wcvw0dcb">
          <path d="M19.573.47a1.594 1.594 0 0 1 2.675.72 1.611 1.611 0 0 1-.414 1.552l-3.663 3.663h5.718c2.639 0 4.778 2.149 4.778 4.8v12.797c0 2.65-2.14 4.799-4.778 4.799v1.6c0 .883-.713 1.599-1.593 1.599s-1.592-.716-1.592-1.6v-1.6H7.963v1.6c0 .884-.713 1.6-1.593 1.6s-1.592-.716-1.592-1.6v-1.6C2.139 28.8 0 26.653 0 24.003V11.204c0-2.65 2.14-4.799 4.778-4.799h6.37L9.698 4.07a1.611 1.611 0 0 1 .004-1.605 1.597 1.597 0 0 1 2.768.005l1.863 3.2zm4.316 9.135H4.778c-.88 0-1.593.716-1.593 1.6v12.797c0 .883.713 1.6 1.593 1.6h19.11c.88 0 1.593-.717 1.593-1.6V11.204c0-.883-.713-1.6-1.592-1.6z" />
        </clipPath>
      </defs>
      <g clipPath="url(#9if3nf3csa)" transform="translate(-228 -690)">
        <g clipPath="url(#65wcvw0dcb)" transform="translate(230 690.5)">
          <path d="M0 0h28.667v32H0V0z" />
        </g>
      </g>
    </svg>
  )
})
